// 10-year preset is effectively a "never expires" option — kept finite so a
// future revocation or policy change can shorten the ceiling without a schema
// migration.
export const EXPIRY_TEN_YEARS_MINUTES = 5_256_000; // 10y * 365d * 24h * 60m

export const EXPIRY_PRESETS: ReadonlyArray<{ value: number; label: string }> = [
  { value: 43200, label: "30 days" },
  { value: 129600, label: "90 days" },
  { value: EXPIRY_TEN_YEARS_MINUTES, label: "10 years" },
];

export const DEFAULT_EXPIRY_MINUTES = 43200;
export const MAX_CUSTOM_EXPIRY_DAYS = 180;

export const CUSTOM_EXPIRY_VALUE = "custom" as const;

export function daysToMinutes(days: number): number {
  return Math.round(days * 1440);
}

export function expiryLabelForMinutes(minutes: number): string {
  const preset = EXPIRY_PRESETS.find((opt) => opt.value === minutes);
  if (preset) return preset.label;
  if (minutes % 1440 === 0) {
    const days = minutes / 1440;
    return `${days} day${days === 1 ? "" : "s"}`;
  }
  if (minutes % 60 === 0) {
    const hours = minutes / 60;
    return `${hours} hour${hours === 1 ? "" : "s"}`;
  }
  return `${minutes} min`;
}
